import log from "loglevel";

export const getLocalStorageValue = (key: string, initialValue: string | null): string | null => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : initialValue;
  } catch (error) {
    log.error(error);
    return initialValue;
  }
};

export const setLocalStorageValue = (key: string, value: string | null) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    log.error(error);
  }
};

export const removeLocalStorageValue = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    log.error(error);
  }
};
